// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VueRouter from 'vue-router';
import axios from 'axios';
import VueWechatTitle from 'vue-wechat-title';
import "video.js/dist/video-js.css";

import jquery from 'jquery'
Vue.prototype.$ = jquery



//保存原型对象的Push
let originPush = VueRouter.prototype.push
let originReplace = VueRouter.prototype.replace
//重写push方法
VueRouter.prototype.push = function (location, res, rej) {
  if (res && rej) {
    originPush.call(this, location, res, rej)
  }
  else {
    originPush.call(this, location, () => { }, () => { })
  }

}
//重写replace方法
VueRouter.prototype.replace = function (location, res, rej) {
  if (res && rej) {
    originReplace.call(this, location, res, rej)
  }
  else {
    originReplace.call(this, location, () => { }, () => { })
  }
}



//引入loading组件插件
import loading from './components/Loading'
//全局注册插件
Vue.component('loading',loading)


//图片懒加载
import VueLazyload from 'vue-lazyload'
// or with options
const loadimage = require('./assets/loading2.gif')
const errorimage = require('./assets/404.jpg')
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorimage,
  loading: loadimage,
  attempt: 3,
})



import {
  Tabbar,
  TabbarItem
} from 'vant';
import {
  NavBar
} from 'vant';
import {
  TreeSelect
} from 'vant';
import {
  Search
} from 'vant';
import {
  Icon
} from 'vant';
import {
  Image
} from 'vant';
import {
  Grid,
  GridItem
} from 'vant';
import {
  Card
} from 'vant';
import {
  Checkbox,
  CheckboxGroup
} from 'vant';
import {
  Button
} from 'vant';
import {
  Swipe,
  SwipeItem
} from 'vant';
import {
  Tab,
  Tabs
} from 'vant';
import { Dialog } from 'vant';
import { Toast } from 'vant';
import { Empty } from 'vant';
import 'vant/lib/index.css';
Vue.use(VueRouter);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(NavBar);
Vue.use(TreeSelect);
Vue.use(Search);
Vue.use(Icon);
Vue.use(Image);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Card);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Button);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Empty);
/* eslint-disable no-new */

/*
import Vconsole from 'vconsole'
let vConsole = new Vconsole()
Vue.use(vConsole)
*/

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)



// 将 axios 作为 Vue 类的原型对象上的一个属性
Vue.prototype.$http = axios

import wx from 'weixin-js-sdk'
Vue.prototype.$wx = wx

new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js